<template>
  <v-autocomplete
    v-model="selectedItems"
    :item-text="itemText"
    :item-value="itemValue"
    :items="items"
    :label="label"
    :search-input.sync="search"
    :multiple="multiple"
    :chips="multiple"
    :clearable="!multiple"
    :clear-icon="$icons.mdiCloseCircle"
    append-icon=""
    :return-object="returnObject"
    hide-no-data
    :hint="hint"
    persistent-hint
    cache-items
    :rules="rules"
    :loading="loading"
    :disabled="disabled"
    @input="onInput"
    @keyup="onKeyUp"
  >
    <!-- following template is important to render html in hint -->
    <template v-slot:message="{ message}">
      <span v-html="message"></span>
    </template>

    <template
      v-if="multiple"
      v-slot:selection="{ item, index }"
    >
      <v-chip
        :close="!disabled"
        @click:close="closeChip(index)"
        color="grey-lighten"
        :close-icon="$icons.mdiCloseCircle"
      >
        <span>{{ item[itemText] }}</span>
      </v-chip>
    </template>

    <template
      v-if="multiple"
      v-slot:item="{ item }"
    >
      <v-list-item-action>
        <v-icon left>{{ getIcon(item) }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ item[itemText] }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import apiRequests from '@/mixins/apiRequests'

export default {
  name: 'Autocomplete',
  mixins: [apiRequests],
  components: {
  },
  props: {
    value: [Array, Number, String, null],
    multiple: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: Array,
    label: String,
    itemText: String,
    itemValue: String,
    hint: String,
    url: String,
    serverSearch: Boolean,
    preSelectedItems: Array,
    minSearchLength: {
      type: Number,
      default: 1
    },
    searchField: {
      type: String,
      default: 'name'
    },
    scope: {
      type: String,
      default: null
    },
    filter: {
      type: String,
      default: null
    },
  },

  data() {
    return {
      loading: false,
      search: null,
      items: [],
      selectedItems: this.value,
    }
  },
  computed: {
  },
  watch: {
  },
  async mounted() {
    if (this.url && !this.serverSearch) {
      this.items = await this.queryItems()
    }
    else if (this.preSelectedItems) {
      this.items = this.preSelectedItems
    }
  },
  methods: {
    async queryItems() {
      const requestParams = {
        method: "GET",
        url: this.url,
        queryParams: {
          ...(this.scope ? { scope: this.scope } : {}),
          ...(this.filter ? { filter: this.filter } : {})
        }
      }
      try {
        const res = await this.osisApiRequest(requestParams)
        return await res.json()
      } catch (error) {
        console.log(error)
      }
    },
    onInput(newValue) {
      if (newValue && typeof newValue === 'object') {
        newValue = newValue.map(item => ({ id: item.id }));
        this.search = ''
      }
      this.$emit('input', newValue);
    },
    async onKeyUp() {
      if (this.serverSearch && this.search && this.search.length >= this.minSearchLength) {
        this.loading = true
        this.items = await this.serverSideSearching()
        this.loading = false
      }
    },
    getIcon(item) {
      let ids = this.selectedItems.map(function (item) { return item.id })
      return ids.includes(item.id) ? this.$icons.mdiCheckboxMarked : this.$icons.mdiCheckboxBlankOutline;
    },
    async serverSideSearching() {
      const requestParams = {
        method: "GET",
        url: this.url,
        queryParams: {
          filter: '{"' + this.searchField + '":"' + this.search + '"}'
        }
      }
      try {
        const res = await this.osisApiRequest(requestParams)
        const data = await res.json()
        return data
      } catch (error) {
        console.log(error)
      }
    },
    closeChip(index) {
      // Remove the chip from the array
      this.selectedItems.splice(index, 1);
      this.onInput(this.selectedItems)
    },
  }
}
</script>

<style>
</style>
